import { msalInstance } from '@sib/auth';

export const updateUserId = () => {
  const userId = msalInstance?.getActiveAccount()?.localAccountId || '';

  localStorage.setItem('userId', userId);

  window.dataLayer.push({
    user_id: userId,
    logged_user_id: userId,
  });
};
